import { SessionHandler } from "verdi-web-client/APICommands/SessionHandler";

interface ReverseGeocodeResponseItem {
    long_name: string; // eg. Canada | Alberta
    short_name: string; // eg. CA | AB
    types: string[]; // from Google Maps API eg. country | administrative_area_level_1
}
export type ReverseGeocodeResults = ReverseGeocodeResponseItem[];

// Based on the type of the error thrown by SessionHandler.doFetch
interface DoFetchErrorResponse {
    status: number;
    message: string;
}

interface ReverseGeocodeRequestParams {
    lat: number;
    lng: number;
}

export const getReverseGeocode = async ({ lat, lng }: ReverseGeocodeRequestParams): Promise<ReverseGeocodeResults> => {
    try {
        const encodedSearchParams = new URLSearchParams({ lat: lat.toString(), lng: lng.toString() });
        const response = await SessionHandler.doFetch(
            `services/geocoding/reverseGeocode?${encodedSearchParams.toString()}`,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "GET",
                redirect: "follow",
            },
        );
        const result = await response.json();
        return result;
    } catch (error: unknown) {
        const doFetchErrorResponse = error as DoFetchErrorResponse;
        const errorMessage = doFetchErrorResponse?.message ?? "Error fetching reverse geocode";
        throw new Error(errorMessage);
    }
};
